import React from "react";
import {
  Box,
  Button,
  Stack,
  Typography,
  ModalWithHeader,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";
// import ModalWithHeader from "./modals/ModalWithHeader";

export const DATA = [
  { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
  { value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },
  { value: "purple", label: "Purple", color: "#5243AA" },
  { value: "red", label: "Red", color: "#FF5630", isFixed: true },
  { value: "orange", label: "Orange", color: "#FF8B00" },
  { value: "yellow", label: "Yellow", color: "#FFC400" },
  { value: "green", label: "Green", color: "#36B37E" },
  { value: "forest", label: "Forest", color: "#00875A" },
  { value: "slate", label: "Slate", color: "#253858" },
  { value: "silver", label: "Silver", color: "#666666" },
];

const BasicModalWithHeaderComp = ({
  disableOutSideClick,
  children,
  icon,
  title,
  subtitle,
  ...rest
}) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Modal with Header
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          height={"300px"}
          language="js"
          value={`
          import { useState } from "react"
          import { Button, ModalWithHeader } from "convertupleads-theme"
          
          export default function PreviewModal() {
            const [open, setOpen] = useState(false)
            return (
              <div>
                <Button onClick={() => setOpen(true)}>
                  Open modal
                </Button>
                <ModalWithHeader
                  open={open}
                  onClose={() => setOpen(false)}
                  title='Please fill the form.'
                >{/*content*/}</ModalWithHeader>
              </div>
            )
          }
          `}
        >
          <Button onClick={handleOpen}>Open modal with header</Button>
          <ModalWithHeader open={open} onClose={handleClose} title={"Header"}>
            {/*<MultiSelect*/}
            {/*  defaultValue={[DATA[0]]}*/}
            {/*  name="colors"*/}
            {/*  options={DATA}*/}
            {/*  components={{ IndicatorSeparator: null }}*/}
            {/*  menuIsOpen*/}
            {/*/>*/}

            <></>
          </ModalWithHeader>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default BasicModalWithHeaderComp;
